export const FARRIS_UPLOADFILE_LOCALEDATA = {
    en: {
        uploadAndPreview: {
            downloadTitle: 'Download Files',
            downloadCount: '{0} Files in Total',
            ok: 'Ok',
            cancel: 'Cancel',
            uploadSelectText: 'Select Files',
            newName: 'New Name',
            filesCount: '<span class="count">{0}</span> Files in Total',
            selectCount: '（<span class="count-selected">{0}</span> Files Selected）',
            download: 'Download',
            delete: 'Delete',
            authMsg: 'You are not authorized to operate attachments',
            nofiles: 'No attachment information',
            uploading: 'Uploading...',
            uploadSuccess: 'Upload succeeded',
            successed: 'Uploaded',
            supportType: 'Support Type',
            maxSize: 'Maximum size of a single file',
            maxFileCount: 'Maximum number of files',
            maxCountShow:' files',
            notAallowedChars: 'Characters not allowed in attachment names',
            columns: {
                name: 'File Name',
                size: 'Size',
                createTime: 'Date',
                state: 'Status',
                action: 'Action',
                number:'Num'
            },
            tips: {
                download: 'Download',
                preview: 'Preview',
                remove: 'Delete',
                edit: 'Edit',
                notedit: 'This type of file does not support online editing'
            },
            multiPreview:'Batch Preview'
        },
        uploadService: {
            failedSameName: 'Upload failed: a file with the same name already exists',
            failedType: 'Upload failed: only documents of type {0} are allowed to be uploaded',
            failedName: 'Upload failed: {0} characters are not allowed in the attachment name',
            failedCount: 'Upload failed: total number of files exceeds {0} limit',
            failedSize: 'Upload failed: file size exceeds {0}MB limit',
            failedEmpty: 'Upload failed: file not allowed to be empty',
            removed: 'Deleted',                
            cancelUpload:'Uploaded Canceled',
            deleteSuccess:'Delete Successful'
        },
        upload: {
            drop: 'Drag File Here',
            select: 'Click to upload',
            back: 'Return',
            orText: 'or',
            hasUploaded: 'Uploaded',
            delText: 'Delete',
            uploading: 'Uploading',
            waitUpload: 'Wait',
            upload: 'Upload',
            remove: 'Remove',
            numFile: 'files',
            continueAdd: 'Continue Selecting',
            mutilUpload: 'Batch Upload',
            cancelUpload: 'Cancel Upload'
        },
        preview: {
            selectAll: 'Select All',
            selected: 'Selected',
            modifyName: 'Modify Name',
            multiDownload: 'Batch Download'           
        }
    },
    'zh-CHS': {
        uploadAndPreview: {
            downloadTitle: '附件下载',
            downloadCount: '等{0}个文件',
            ok: '确定',
            cancel: '取消',
            newName: '文件名',
            uploadSelectText: '上传附件',
            filesCount: '共<span class="count">{0}</span>个附件',
            selectCount: '（已选<span class="count-selected">{0}</span>个）',
            download: '下载',
            delete: '删除',
            authMsg: '您无权操作附件',
            nofiles: '无附件信息',
            uploading: '正在上传...',
            uploadSuccess: '上传成功',
            successed: '已上传',
            supportType: '支持类型',
            maxSize: '单个文件限制',
            maxFileCount: '文件总数限制',
            maxCountShow:'个',
            notAallowedChars: '附件名称中不允许包含的字符',
            columns: {
                name: '文件名',
                size: '大小',
                createTime: '日期',
                state: '状态',
                action: '操作',
                number:'序号'
            },
            tips: {
                download: '下载',
                preview: '预览',
                remove: '删除',
                edit: '编辑',
                notedit: '此类型文件不支持在线编辑'
            },
            multiPreview:'批量预览'
        },
        uploadService: {
            failedSameName: '上传失败：已存在同名文件',
            failedType: '上传失败：只允许上传{0}类型的文档',
            failedName: '上传失败：附件名称中不允许{0}这些字符',
            failedCount: '上传失败：文件总个数超出{0}限制',
            failedSize: '上传失败：单个文件大小超出{0}MB的限制',
            failedEmpty: '上传失败：不允许文件为空',
            removed: '被删除',
            cancelUpload:'已取消附件上传',
            deleteSuccess:'删除附件成功'
        },
        upload: {
            drop: '可将文件拖拽此处',
            select: '点击上传',
            back: '返回',
            orText: '或',
            hasUploaded: '已上传',
            delText: '删除',
            uploading: '上传中',
            waitUpload: '待上传',
            upload: '上传',
            remove: '移除',
            numFile: '个文件',
            continueAdd: '继续添加',
            mutilUpload: '批量上传',
            cancelUpload: '取消上传'
        },
        preview: {
            selectAll: '全选',
            selected: '已选',
            modifyName: '修改名称',
            multiDownload: '批量下载'
        }
    },
    'zh-CHT': {
        uploadAndPreview: {
            downloadTitle: '附件下載',
            downloadCount: '等{0}個文件',
            ok: '確定',
            cancel: '取消',
            newName: '文件名',
            uploadSelectText: '上傳附件',
            filesCount: '共<span class="count">{0}</span>個附件',
            selectCount: '（已選<span class="count-selected">{0}</span>個）',
            download: '下載',
            delete: '刪除',
            authMsg: '您無權操作附件',
            nofiles: '無附件信息',
            uploading: '正在上傳...',
            uploadSuccess: '上傳成功',
            successed: '已上傳',
            supportType: '支持類型',
            maxSize: '單個文件限制',
            maxFileCount: '文件總數限制',
            maxCountShow:'個',
            notAallowedChars: '附件名稱中不允許包含的字元',
            columns: {
                name: '文件名',
                size: '大小',
                createTime: '日期',
                state: '狀態',
                action: '操作',
                number:'序號'
            },
            tips: {
                download: '下載',
                preview: '預覽',
                remove: '删除',
                edit: '編輯',
                notedit: '此類型文件不支持在線編輯'
            },
            multiPreview:'批量預覽'
        },
        uploadService: {
            failedSameName: '上傳失敗：已存在同名檔案',
            failedType: '上傳失敗：只允許上傳{0}類型的檔案',
            failedName: '上傳失敗：附件名稱中不允許{0}這些字元',
            failedCount: '上傳失敗：檔案總個數超出{0}限制',
            failedSize: '上傳失敗：單個文件大小超出 {0}mb 的限制',
            failedEmpty: '上傳失敗：不允許檔案為空',
            removed: '被删除',            
            cancelUpload:'已取消附件上傳',
            deleteSuccess:'删除附件成功'
        },
        upload: {
            drop: '可將檔案拖拽此處',
            select: '點擊上傳',
            back: '返回',
            orText: '或',
            hasUploaded: '已上傳',
            delText: '删除',
            uploading: '上傳中',
            waitUpload: '待上傳',
            upload: '上傳',
            remove: '移除',
            numFile: '個檔案',
            continueAdd: '繼續添加',
            mutilUpload: '批量上傳',
            cancelUpload: '取消上傳'
        },
        preview: {
            selectAll: '全選',
            selected: '已選',
            modifyName: '修改名稱',
            multiDownload: '批量下載'
        }
    }
}